import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useStyles } from "../Utils/Styles";

export default function ControlPanel(props) {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  return (
    <Grid container spacing={3}>
      {/* All the admin items as badges */}
      <Grid item xs={3}>
        <Paper
          onClick={() => {
            history.push("/cpanel/users");
          }}
          className={fixedHeightPaper}
        >
          <Typography>{t("controlPanel.users")}</Typography>
        </Paper>
      </Grid>
      <Grid item xs={3}>
        <Paper
          onClick={() => {
            history.push("/cpanel/devices");
          }}
          className={fixedHeightPaper}
        >
          <Typography>{t("controlPanel.devices")}</Typography>
        </Paper>
      </Grid>
      <Grid item xs={3}>
        <Paper
          onClick={() => {
            history.push("/cpanel/companies");
          }}
          className={fixedHeightPaper}
        >
          <Typography>{t("controlPanel.companies")}</Typography>
        </Paper>
      </Grid>
      <Grid item xs={3}>
        <Paper
          onClick={() => {
            history.push("/cpanel/settings");
          }}
          className={fixedHeightPaper}
        >
          <Typography>{t("controlPanel.settings")}</Typography>
        </Paper>
      </Grid>
    </Grid>
  );
}
